/** Tooltip helpers for estimated strength-growth boundary values (Plans 048, 049). */

export function shortDate(iso: string) {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  });
}

function describe(label: string, range: [string, string]) {
  const [before, after] = range;
  return before === after
    ? `${label} value taken from the report on ${shortDate(before)}`
    : `${label} value estimated between reports on ${shortDate(before)} and ${shortDate(after)}`;
}

export function estimateHint(
  from: [string, string] | null,
  to: [string, string] | null,
): string | undefined {
  const hints = [
    from && describe('Start', from),
    to && describe('End', to),
  ].filter(Boolean);
  return hints.length > 0 ? hints.join('. ') : undefined;
}
